// src/redux/slices/aiChatSlice.jsx
import { createSlice } from "@reduxjs/toolkit";

const aiChatSlice = createSlice({
  name: "aiChat",
  initialState: {
    aiUsers: [],
  },
  reducers: {
    setAIUserList: (state, action) => {
      state.aiUsers = action.payload;
    },
  },
});

export const { setAIUserList } = aiChatSlice.actions;
export default aiChatSlice.reducer;
